import React from "react";
import SmartBackLink from "./SmartBackLink";

export default function LegalLayout({ title, eyebrow = "Legal", lastUpdated, children }) {
  return (
    <div className="min-h-screen bg-[#f7f3ea]">
      <header className="px-6 py-6 max-w-4xl mx-auto flex items-center justify-between">
        <SmartBackLink />
        <div className="flex items-center gap-1">
          <span className="font-display text-[20px] font-semibold text-[#0f1724]">ascend</span>
          <span className="font-display text-[20px] font-semibold text-[#486a8f]">higher</span>
        </div>
      </header>
      <main className="max-w-3xl mx-auto px-6 pb-24">
        <p className="font-mono-eyebrow text-[#486a8f] mb-3">{eyebrow}</p>
        <h1 className="font-display text-[40px] md:text-[48px] leading-[1.05] text-[#0f1724] tracking-tight mb-3">
          {title}
        </h1>
        {lastUpdated && (
          <p className="font-body text-[13px] text-[#6b7280] mb-10">Last updated: {lastUpdated}</p>
        )}
        <div className="prose-content font-body text-[15px] leading-[1.75] text-[#2b3442] space-y-5">
          {children}
        </div>
      </main>
    </div>
  );
}
